import React from 'react';
import HeroSection from '../Components/HeroSection';
import { FoldingLogos } from '../Components/FoldingLogos';
import { BouncyCardsFeatures } from '../Components/BouncyCardsFeatures';
import CollapseCardFeatures from '../Components/CollapseCardFeatures';
import { Helmet } from "react-helmet";

const Portfolio = () => {
  // Define the title and description variables
  const title = 'Turning Ideas into Impactful Digital Solutions';

  const description = (
    <>
      Welcome to a showcase of projects where vision meets execution. Each case study highlights
      my dedication to blending design, development, and strategy, delivering results that empower
      brands to thrive online.
    </>
  );

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://plambech.dev/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Portfolio",
        "item": "https://plambech.dev/portfolio"
      }
    ]
  };

  return (
    <div>
    <Helmet>
      <title>Portfolio | Projects by Plambech Development</title>
      <meta name="description" content="Explore the portfolio of freelance developer Rasmus Plambech, showcasing custom WordPress and PHP projects delivered over the past 11 years." />
      <link rel="canonical" href="https://plambech.dev/portfolio" />

      {/* Open Graph Tags */}
      <meta property="og:title" content="Portfolio | Projects by Plambech Development" />
      <meta property="og:description" content="Explore the portfolio of freelance developer Rasmus Plambech, showcasing custom WordPress and PHP projects delivered over the past 11 years." />
      <meta property="og:url" content="https://plambech.dev/portfolio" />

      {/* Twitter Card Tags */}
      <meta name="twitter:title" content="Portfolio | Projects by Plambech Development" />
      <meta name="twitter:description" content="Explore the portfolio of freelance developer Rasmus Plambech, showcasing custom WordPress and PHP projects delivered over the past 11 years." />

      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>

      {/* Pass the variables as props to HeroSection */}
      <HeroSection
        title={title}
        description={description}
        buttonText="See what I can do for you!"
        buttonLink="/services"
      />
      <BouncyCardsFeatures />
      <CollapseCardFeatures />
      <FoldingLogos />
    </div>
  );
};

export default Portfolio;